import { ContentWithAside } from "layouts/kiosk-h"

import { themeOptionFactories } from "./theme"

import { EmTransportationPage } from "./pages/em-transportation"
import { EmTaxiTransportationKioskHPage } from "./pages/em-transportation/taxi/index.kiosk"
import { EmTransportationKioskHPage } from "./pages/em-transportation/index.kiosk"
import { EmBusTransportationKioskHPage } from "./pages/em-transportation/bus/index.kiosk"
import { EmBtsTransportationKioskHPage } from "./pages/em-transportation/bts/index.kiosk"

import { EmBusTransportationMobilePage } from "./pages/em-transportation/bus"
import { EmBtsTransportationMobilePage } from "./pages/em-transportation/bts"
import { EmTaxiTransportationMobilePage } from "./pages/em-transportation/taxi"

export const emTransportation = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "transportation",
        element: <EmTransportationPage />,
      },
      {
        path: "transportation/taxi",
        element: <EmTaxiTransportationMobilePage />,
      },
      {
        path: "transportation/bus",
        element: <EmBusTransportationMobilePage />,
      },
      {
        path: "transportation/bts",
        element: <EmBtsTransportationMobilePage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "transportation",
        element: <EmTransportationKioskHPage Layout={ContentWithAside} />,
      },
      {
        path: "transportation/taxi",
        element: <EmTaxiTransportationKioskHPage Layout={ContentWithAside} />,
      },
      {
        path: "transportation/bus",
        element: <EmBusTransportationKioskHPage Layout={ContentWithAside} />,
      },
      {
        path: "transportation/bts",
        element: <EmBtsTransportationKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
